export enum FeatureEntitlements {
  StorefrontBrandingCustomFonts = 'storefront_branding_custom_fonts',
  ScanAndPayRetailers = 'scan_and_pay_retailers',
  PageBuilder = 'page_builder',
}
